import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import {
  LinkIcon,
  AdobeCompanyLetter,
  AirbnbCompanyLetter,
  AmazonCompanyLetter,
  AppleCompanyLetter,
  CampbellSoupCompanyLetter,
  ComcastCompanyLetter,
  DisneyCompanyLetter,
  GoogleCompanyLetter,
  MetaCompanyLetter,
  MicrosoftCompanyLetter,
  NetflixCompanyLetter,
  PinterestCompanyLetter,
  QualcommCompanyLetter,
  VisaCompanyLetter,
  //
  CompanyLetter202211,
  CompanyLetter202302,
} from '../'
import Styles from './PlanScorecardCompanyLetter.css'

@CSSModules(Styles, {allowMultiple: true})
export default class PlanScorecardCompanyLetter extends Component {
  static propTypes = {
    planPath: PropTypes.string.isRequired,
    url: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      planPath: this.props.planPath,
      show: this.props.url.hash === '#letter',
      //
      //
      //
      companiesWithLetter: [
        'adobe',
        'airbnb',
        'amazon_com',
        'apple',
        'booking_holdings',
        'broadcom',
        'campbell_soup',
        'chipotle',
        'comcast',
        'disney',
        'dollar_general',
        'etsy',
        'fedex',
        'google',
        'intuit',
        'meta',
        'microsoft',
        'netflix',
        'oracle',
        'pinterest',
        'progressive',
        'prologis',
        'qualcomm',
        'quanta_services',
        'regeneron_pharmaceuticals',
        'stryker',
        'take_two_interactive_software',
        'target',
        'tesla',
        'tjx_companies',
        'vertex_pharmaceuticals',
        'visa',
      ],
      //
      //
      //
      letterConfig202211: {
        broadcom: {
          companyName: 'Broadcom',
          companyPath: 'broadcom',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Tan',
          addressee: (
            <span>
              Hock Tan<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              1320 Ridder Park Dr.<br/>
              San Jose, CA<br/>
              95131
            </span>
          ),
          aspirationalGoal: 'goals to manage our business in a sustainable manner that considers the impact of both our direct operations and supply chain on the planet',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$6.9 billion',
        },
        chipotle: {
          companyName: 'Chipotle Mexican Grill',
          companyPath: 'chipotle',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Niccol',
          addressee: (
            <span>
              Brian Niccol<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              610 Newport Center Dr.<br/>
              Newport Beach, CA<br/>
              92660
            </span>
          ),
          aspirationalGoal: 'its commitment to reducing our absolute Scope 1, 2, and 3 greenhouse gas emissions by 50% by 2030, from a 2019 base year',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$159 million',
        },
        fedex: {
          companyName: 'FedEx',
          companyPath: 'fedex',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Subramaniam',
          addressee: (
            <span>
              Raj Subramaniam<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              942 S Shady Grove Rd.<br/>
              Memphis, TN<br/>
              38120
            </span>
          ),
          aspirationalGoal: 'its commitment to working toward delivering a more sustainable future including a goal of carbon neutral operations by 2040',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$23.1 billion',
        },
        intuit: {
          companyName: 'Intuit',
          companyPath: 'intuit',
          letterDate: 'November 1, 2022',
          addresseeSurname: 'Mr. Goodarzi',
          addressee: (
            <span>
              Sasan Goodarzi<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              2700 Coast Ave<br/>
              Mountain View, CA<br/>
              94043
            </span>
          ),
          aspirationalGoal: 'its goal to help one million small businesses reduce their carbon emissions by 50% by 2030',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$2.3 billion',
        },
        oracle: {
          companyName: 'Oracle',
          companyPath: 'oracle',
          letterDate: 'November 1, 2022',
          addresseeSurname: 'Ms. Catz',
          addressee: (
            <span>
              Safra A. Catz<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              2300 Oracle Way<br/>
              Austin, TX<br/>
              78741
            </span>
          ),
          aspirationalGoal: 'its target of 100% renewable energy use by 2025, and the goal to achieve Net Zero emissions by 2050',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$23.6 billion',
        },
        stryker: {
          companyName: 'Stryker',
          companyPath: 'stryker',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Lobo',
          addressee: (
            <span>
              Kevin Lobo<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              2825 Airview Blvd<br/>
              Portage, MI<br/>
              49002
            </span>
          ),
          aspirationalGoal: 'its committed goals of making our Scope 1 and Scope 2 greenhouse gas emissions carbon neutral by 2030',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$4 billion',
        },
        target: {
          companyName: 'Target',
          companyPath: 'target',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Liu',
          addressee: (
            <span>
              Don Liu<br/>
              Corporate Secretary
            </span>
          ),
          address: (
            <span>
              1000 Nicollet Mall<br/>
              Minneapolis, MN<br/>
              55403
            </span>
          ),
          aspirationalGoal: 'its 2040 goal to have 100% of our owned brand products be designed for a circular future',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Fidelity Freedom Blend series',
          planAssets: '$11.6 billion',
        },
        tesla: {
          companyName: 'Tesla',
          companyPath: 'tesla',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Musk',
          addressee: (
            <span>
              Elon Musk<br/>
              Chief Executive Officer
            </span>
          ),
          address: (
            <span>
              13101 Harold Green Road<br/>
              Austin, Texas<br/>
              78725
            </span>
          ),
          aspirationalGoal: 'its mission to transition to a carbon neutral economy and usher a new sustainable business model for the transportation industry based on zero emissions',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'T. Rowe Price Retirement series',
          planAssets: '$849.5 million',
        },
      },
      //
      //
      //
      letterConfig202302 : {
        //
        //
        booking_holdings: {
          companyName: 'Booking Holdings',
          companyPath: 'booking-holdings',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Sonne',
          addressee: (
            <span>
              Steve Sonne<br/>
              Corporate Secretary
            </span>
          ),
          aspirationalGoal: 'its goal to achieve 95% Scope 1 & 2 reduction target by 2030, and achieve net zero by 2040',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$389 million',
        },
        //
        //
        dollar_general: {
          companyName: 'Dollar General',
          companyPath: 'dollar-general',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Connolly',
          addressee: (
            <span>
              Christine Connolly<br/>
              Vice President, Corporate Secretary and Chief Compliance Officer
            </span>
          ),
          aspirationalGoal: 'its goal to committed to an 15% emissions reduction per square foot by 2026 and a 30% reduction per square foot by 2031, each versus a baseline year of 2020',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'T. Rowe Price Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$682 million',
        },
        //
        //
        etsy: {
          companyName: 'Etsy',
          companyPath: 'etsy',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Silverman',
          addressee: (
            <span>
              Josh Silverman<br/>
              Chief Executive Officer
            </span>
          ),
          aspirationalGoal: 'its goal to achieve a 50% absolute reduction in Scope 1 and 2 GHG emissions and a 52% reduction in Scope 3 GHG emissions per dollar of gross profit from a 2020 base year, by year end 2030',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$129 million',
        },
        //
        //
        progressive: {
          companyName: 'Progressive',
          companyPath: 'progressive',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Griffith',
          addressee: (
            <span>
              Tricia Griffith<br/>
              President and Chief Executive Officer
            </span>
          ),
          aspirationalGoal: 'its goal to become carbon neutral for Scopes 1 and 2 emissions by the end of 2025',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$8 billion',
        },
        //
        //
        prologis: {
          companyName: 'Prologis',
          companyPath: 'prologis',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Moghadam',
          addressee: (
            <span>
              Hamid Moghadam<br/>
              Chairman  and Chief Executive Officer
            </span>
          ),
          aspirationalGoal: 'its commitment to achieve net zero emissions across its entire value chain by 2040',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$351 million',
        },
        //
        //
        quanta_services: {
          companyName: 'Quanta Services',
          companyPath: 'quanta-services',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Riddle',
          addressee: (
            <span>
              Kim Riddle<br/>
              Vice President, Human Resources
            </span>
          ),
          aspirationalGoal: 'its achievement of building significant environmental reporting capacity, enabling the collection of CO2 emissions data across 70,000+ vehicle assets and 1,000+ owned and leased properties',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom Blend series',
          noFewEsgOptions: 'no',
          planAssets: '$1.4 billion',
        },
        //
        //
        regeneron_pharmaceuticals: {
          companyName: 'Regeneron Pharmaceuticals',
          companyPath: 'regeneron-pharmaceuticals',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. LaRosa',
          addressee: (
            <span>
              Joseph LaRosa<br/>
              Executive Vice President, General Counsel and Secretary
            </span>
          ),
          aspirationalGoal: 'its goal to match 50% of its electricity consumption with electricity from certified renewable energy sources by 2025, and match 100% of electricity consumption by 2035',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$1.7 billion',
        },
        //
        //
        take_two_interactive_software: {
          companyName: 'Take-Two Interactive Software',
          companyPath: 'take-two-interactive-software',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Zelnick',
          addressee: (
            <span>
              Strauss Zelnick<br/>
              Chairman and Chief Executive Officer
            </span>
          ),
          aspirationalGoal: 'its goal to focus on and measure the impact of our ESG activities',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom Index series',
          noFewEsgOptions: 'no',
          planAssets: '$416 million',
        },
        //
        //
        tjx_companies: {
          companyName: 'TJX Companies',
          companyPath: 'tjx-companies',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Botte',
          addressee: (
            <span>
              Jeff Botte<br/>
              Vice President, Investor Relations
            </span>
          ),
          aspirationalGoal: 'its goal to achieve net-zero GHG emissions in operations by 2040, and source 100% renewable energy in operations by 2030',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$3.7 billion',
        },
        //
        //
        vertex_pharmaceuticals: {
          companyName: 'Vertex Pharmaceuticals',
          companyPath: 'vertex-pharmaceuticals',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Kewalramani',
          addressee: (
            <span>
              Reshma Kewalramani<br/>
              President and Chief Executive Officer
            </span>
          ),
          aspirationalGoal: 'our goal to reduce our global GHG emissions by 20% by 2023 (on an absolute basis)',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom series',
          noFewEsgOptions: 'no',
          planAssets: '$920 million',
        }
      }
    }
  }

  render() {
    const { planPath, show } = this.state

    if (!this.state.companiesWithLetter.includes(planPath)){
      return null
    }

    return (
      <div styleName='plan-scorecard-company-letter'>
        <div styleName='anchor' id='letter' />
        <button
          styleName='section-slidedown-button'
          onClick={
            (e)=>{
              this.setState({
                show: !show
              })
            }
          }
        >
          <h2 styleName='section-slidedown-label'>
            Our letter to company management
          </h2>
          <div styleName='section-slidedown-icon'>
            <LinkIcon faclass={ show ? 'fa-angle-up' : 'fa-angle-down' } />
          </div>
        </button>
        <SlideDown>
          { show && planPath==='adobe' ? <AdobeCompanyLetter /> : null }
          { show && planPath==='airbnb' ? <AirbnbCompanyLetter /> : null }
          { show && planPath==='amazon_com' ? <AmazonCompanyLetter /> : null }
          { show && planPath==='apple' ? <AppleCompanyLetter /> : null }
          { show && planPath==='campbell_soup' ? <CampbellSoupCompanyLetter /> : null }
          { show && planPath==='comcast' ? <ComcastCompanyLetter /> : null }
          { show && planPath==='disney' ? <DisneyCompanyLetter /> : null }
          { show && planPath==='google' ? <GoogleCompanyLetter /> : null }
          { show && planPath==='meta' ? <MetaCompanyLetter /> : null }
          { show && planPath==='microsoft' ? <MicrosoftCompanyLetter /> : null }
          { show && planPath==='netflix' ? <NetflixCompanyLetter /> : null }
          { show && planPath==='pinterest' ? <PinterestCompanyLetter /> : null }
          { show && planPath==='qualcomm' ? <QualcommCompanyLetter /> : null }
          { show && planPath==='visa' ? <VisaCompanyLetter /> : null }

          { /* 202211 letters */
            show && (planPath==='broadcom' ||
                     planPath==='chipotle' ||
                     planPath==='fedex' ||
                     planPath==='intuit' ||
                     planPath==='oracle' ||
                     planPath==='stryker' ||
                     planPath==='target' ||
                     planPath==='tesla') ?
              (
                <CompanyLetter202211
                  letterConfig={this.state.letterConfig202211[planPath]}
                />
              ) :
              null
          }

          { /* 202302 letters */
            show && (planPath==='booking_holdings' ||
                     planPath==='dollar_general' ||
                     planPath==='etsy' ||
                     planPath==='progressive' ||
                     planPath==='prologis' ||
                     planPath==='quanta_services' ||
                     planPath==='regeneron_pharmaceuticals' ||
                     planPath==='take_two_interactive_software' ||
                     planPath==='tjx_companies' ||
                     planPath==='vertex_pharmaceuticals') ?
              (
                <CompanyLetter202302
                  letterConfig={this.state.letterConfig202302[planPath]}
                />
              ) :
              null
          }

        </SlideDown>
      </div>
    )
  }
}